import React from 'react';
import * as Styles from './UnifyBillingCycleSubscriptionPage.styles';
import { UnifyBillingCycleSubscriptionHandler } from '@/components/billing';

const UnifyBillingCycleSubscriptionPage = () => (
  <Styles.Wrapper data-testid="billing-cycle-unify-subscription-page">
    <UnifyBillingCycleSubscriptionHandler />
  </Styles.Wrapper>
);

export default UnifyBillingCycleSubscriptionPage;
